import fr from '@/i18n/locales/fr.json'
import en from '@/i18n/locales/en.json'

const message = { fr, en }

export default message
